import React from 'react'
// import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as ReactBootstrap from 'react-bootstrap'
import DateTimeField from 'react-datetime'
import moment from 'moment'
import './AddAccount.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import { getCountryList } from '../../actions/country'
import { getBrandList } from '../../actions/brands'
import { getUserAccountDetails } from '../../actions/userAccounts'
import { getDistributorList } from '../../actions/distributor'
import { getRegionList } from '../../actions/region'
import Api from '../../Api'
import CommonLoader from '../Alerts/CommonLoader'
import { CountryOptions } from '../Common/Country'

class AdminAccountInfo extends React.Component {
  constructor (props) {
    super(props)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      User_ID: 0,
      User_UID: '',
      Company_Name: '',
      Company_Type: '',
      Company_AvanteCust_ID: '',
      Company_Country_ID: 1,
      Company_ID: 0,
      Company_UID: '',
      Company_Region: '',
      Distributor_id: 0,
      Brand_UID: '',
      User_FirstName: '',
      User_LastName: '',
      User_EmailAddress: '',
      User_EmailAddress_confirm: '',
      Account_StartDate: '',
      Account_EndDate: '',
      Account_Subscription_radio: '4',
      Account_Subscription_ID: 4,
      Account_ID: 0,
      Account_UID: '',
      updateSubscriptionId: 0,
      Account_IsTest: 0,
      Account_TOS_Browser: '',
      Account_IsDFA: 0,
      successMessage: '',
      successType: '',
      saveSuccess: false,
      errors: [],
      regioncalled: false,
      update: false,
      leaderBoard: false,
      updatedEmail: '',
      LBVersion: 0,
      show: false,
      LeaderboardMode_ID: 0,
      style: 'create',
      showCommonLoader: false
    }
    this.api = new Api()
    this.updateRegion = this.updateRegion.bind(this)
  }

  componentWillMount () {
    const params = new URLSearchParams(this.props.history.location.search)
    const type = params.get('type')
    const uuid = params.get('uuid') || params.get('useruid')
    var capitalizeString = type.charAt(0).toUpperCase() + type.slice(1)
    this.props.getUserAccountDetails(uuid, function () {
      let accountData = this.props.userAccounts[0]
      this.setState({
        User_ID: accountData.User_ID,
        User_UID: accountData.User_UID,
        User_FirstName: accountData.User_FirstName,
        User_LastName: accountData.User_LastName,
        User_EmailAddress: accountData.User_EmailAddress,
        updatedEmail: accountData.User_EmailAddress,
        User_EmailAddress_confirm: accountData.User_EmailAddress,
        Company_Name: accountData.Company_Name,
        Company_Type: accountData.Company_Type,
        Company_ID: accountData.Company_ID,
        Company_UID: accountData.Company_UID,
        Company_AvanteCust_ID: accountData.Company_AvanteCust_ID,
        Company_Country_ID: accountData.Company_Country_ID,
        Company_Region: accountData.Company_Region,
        Brand_UID: accountData.Brand_UID,
        Distributor_id: accountData.Distributor_id,
        Account_ID: accountData.Account_ID,
        Account_UID: accountData.Account_UID,
        Account_IsTest: accountData.Account_IsTest ? 1 : 0,
        Account_IsDFA: accountData.Account_DFA_IsDFA ? 1 : 0,
        Account_Subscription_radio: accountData.Account_Subscription_ID.toString(),
        Account_Subscription_ID: accountData.Account_Subscription_ID,
        Account_StartDate: (accountData.Account_StartDate) ? moment(accountData.Account_StartDate.replace('Z', '')).format('MM/DD/YYYY') : '', // replace 'Z' with blank to avoid zone datetime convertion
        Account_EndDate: (accountData.Account_EndDate) ? moment(accountData.Account_EndDate.replace('Z', '')).format('MM/DD/YYYY') : '', // replace 'Z' with blank to avoid zone datetime convertion
        LeaderboardMode_ID: accountData.LeaderboardMode_ID,
        update: true
      })
      if (this.state.Company_Type !== 'Corporation') {
        this.setState({
          Brand_UID: ''
        })
      }
      if (this.state.update && this.state.Account_Subscription_radio !== '3') {
        this.setState({
          updateSubscriptionId: 1
        })
      }
      if (this.state.update && this.state.Account_Subscription_radio === '6') {
        this.setState({
          leaderBoard: true
        })
        if (this.state.update && this.state.LeaderboardMode_ID === 1) {
          this.setState({
            LBVersion: 'hme'
          })
        }
        if (this.state.update && this.state.LeaderboardMode_ID === 2) {
          this.setState({
            LBVersion: 'azure'
          })
        }
      }
      if (this.state.update && this.state.Account_Subscription_radio === '3') {
        this.setState({
          LBVersion: 'hme'
        })
      }
      console.log('this state 1', this.state)
    }.bind(this))
    this.setState({
      Company_Type: capitalizeString
    })
    console.log('this state 2', this.state)
  }
  handleInputChange (e) {
    if (e.target.name === 'Company_Country_ID' || e.target.name === 'Distributor_id') {
      let targetValue = parseInt(e.target.value)
      if (e.target.name === 'Company_Country_ID') {
        if (targetValue === 1) {
          this.updateRegion(targetValue)
        } else {
          this.setState({
            Company_Region: ''
          })
        }
        this.setState({
          [e.target.name]: targetValue
        })
      } else {
        this.setState({
          [e.target.name]: targetValue
        })
      }
    } else if (e.target.name === 'Company_Type') {
      if (e.target.value !== 'Corporation') {
        this.setState({
          Brand_UID: '',
          [e.target.name]: e.target.value
        })
      } else {
        this.setState({
          [e.target.name]: e.target.value
        })
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  }

  handleRadioChange (e, value) {
    this.setState({
      Account_Subscription_radio: e.target.value,
      Account_Subscription_ID: parseInt(e.target.value)
    })
    if (this.state.update && value === 6) {
      this.setState({
        leaderBoard: true,
        LBVersion: 'azure'
      })
    } else {
      this.setState({
        leaderBoard: false,
        LBVersion: 'hme'
      })
    }
  }

  handleCheckboxChange (e, result) {
    this.setState({
      [e.target.name]: result ? 1 : 0
    })
  }

  changeDate (date, dateSelection) {
    let selectedDate = moment(date, 'MM/DD/YYYY').format('MM/DD/YYYY')
    if (dateSelection === 'from') {
      this.setState({
        Account_StartDate: selectedDate
      })
    } else if (dateSelection === 'to') {
      this.setState({
        Account_EndDate: selectedDate
      })
    }
  }

  cancelPremiumPopShow () {
    this.setState({
      show: true
    })
  }
  cancelPremiumPopHide () {
    this.setState({
      show: false
    })
  }
  cancelPremium () {
    this.setState({
      showCommonLoader: true
    })
    const url = Config.apiBaseUrl + CommonConstants.apiUrls.cancelPremiumSubscription
    let data = this.state
    this.api.postData(url, data, result => {
      if (result.status) {
        this.setState({ show: false, saveSuccess: true, successMessage: 'done', successType: 'premium', showCommonLoader: false })
      } else {
        let errors = []
        errors.push('Something went wrong')
        this.setState({
          errors: errors,
          show: false,
          showCommonLoader: false
        })
      }
    })
  }

  handleActivation () {
    this.setState({
      showCommonLoader: true
    })
    const url = Config.apiBaseUrl + CommonConstants.apiUrls.activateAccount
    let data = this.state
    this.api.postData(url, data, result => {
      if (result.status) {
        this.setState({ saveSuccess: true, successMessage: 'An activation email has been sent!', successType: 'message', style: 'update', showCommonLoader: false })
      } else {
        let errors = []
        errors.push('Something went wrong')
        this.setState({
          errors: errors,
          showCommonLoader: false
        })
      }
    })
  }
  handleSubmit () {
    this.setState({ showCommonLoader: true })
    let errors = []
    if (!this.state.User_EmailAddress) {
      errors.push('Email address may not be blank.')
    }
    let atpos = this.state.User_EmailAddress.indexOf('@')
    let dotpos = this.state.User_EmailAddress.lastIndexOf('.')
    let userEmailAddressConfirmAtpos = this.state.User_EmailAddress_confirm.indexOf('@')
    let userEmailAddressConfirmDotpos = this.state.User_EmailAddress_confirm.lastIndexOf('.')
    if (userEmailAddressConfirmAtpos < 1 || userEmailAddressConfirmDotpos < userEmailAddressConfirmAtpos + 2 || userEmailAddressConfirmDotpos + 2 >= this.state.User_EmailAddress_confirm.length) {
      // errors.push('Email address is invalid. Please try again')
      errors.push('Please confirm your email address')
    }
    // if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= this.state.User_EmailAddress.length) {
    //   errors.push('Email address may not be blank')
    //   //errors.push('Please confirm your email address')
    // }
    if (!this.state.User_FirstName) {
      errors.push('Please provide your first name.')
    }
    if (!this.state.User_LastName) {
      errors.push('Please provide your last name.')
    }
    if (!this.state.Company_Name) {
      errors.push('Please provide your company name.')
    }
    if (this.state.Company_Type === 'Corporation' && (this.state.Brand_UID === '' || this.state.Brand_UID === null)) {
      errors.push('Please select a brand for this corporation.')
    }
    if (!this.state.Company_Region) {
      errors.push('Please provide your state/province.')
    }
    if (!this.state.Company_AvanteCust_ID) {
      errors.push('Please provide your avante number.')
    }
    if (!this.state.Account_StartDate) {
      errors.push('Please provide a subscription start date.')
    }
    if (!this.state.Account_EndDate) {
      errors.push('Please provide a subscription end date.')
    }
    this.setState({
      errors: errors
    })
    if (
      this.state.User_FirstName && this.state.User_LastName && this.state.Company_AvanteCust_ID &&
      this.state.Company_Name && this.state.Company_Region && this.state.User_EmailAddress &&
      this.state.Account_StartDate && this.state.Account_EndDate &&
      ((this.state.Company_Type === 'Corporation' && (this.state.Brand_UID !== '' && this.state.Brand_UID !== null)) ||
        this.state.Company_Type !== 'Corporation') &&
      !(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= this.state.User_EmailAddress.length)
    ) {
      if (this.state.User_EmailAddress !== this.state.User_EmailAddress_confirm) {
        let errors = []
        errors.push('Email address do not match.')
        this.setState({
          errors: errors,
          showCommonLoader: false
        })
      } else {
        let data = this.state
        const url = Config.apiBaseUrl + CommonConstants.apiUrls.saveAdminAccount
        const urlUpdate = Config.apiBaseUrl + CommonConstants.apiUrls.updateAdminAccount
        if (!this.state.update) {
          this.api.postData(url, data, result => {
            if (result.status) {
              this.setState({ saveSuccess: true, successMessage: 'User Sign Up Successful', successType: 'message', style: 'create', showCommonLoader: false })
            } else {
              if (result.reason === 'emailused') {
                let errors = []
                errors.push('Email address is already in use.')
                this.setState({
                  errors: errors,
                  showCommonLoader: false
                })
              } else if (result.reason === 'dtdsconnectionerror') {
                errors.push('Account updated! DTDS connection refuse: CompanySettings is not been push to Azure')
                this.setState({
                  errors: errors,
                  showCommonLoader: false
                })
              }
            }
          })
        } else {
          this.api.postData(urlUpdate, data, result => {
            if (result.status) {
              this.setState({ saveSuccess: true, successMessage: 'Record Saved!', successType: 'message', style: 'update', showCommonLoader: false })
            } else {
              let errors = []
              if (result.reason === 'emailused') {
                errors.push('Email address is already in use.')
                this.setState({
                  errors: errors,
                  showCommonLoader: false
                })
              } else if (result.reason === 'dtdsconnectionerror') {
                errors.push('Account updated! DTDS connection refuse: CompanySettings is not been push to Azure')
                this.setState({
                  errors: errors,
                  showCommonLoader: false
                })
              }
            }
          })
        }
      }
    } else {
      this.setState({ showCommonLoader: false })
    }
  }

  updateRegion (countryID) {
    this.props.getRegionList(countryID)
  }

  componentDidMount () {
    this.props.getDistributorList()
    this.props.getCountryList()
    this.props.getBrandList()
    this.props.getRegionList(1)
  }

  renderErrors () {
    if (this.state.errors.length) {
      return this.state.errors.map(item => {
        return (
          <li>{item}</li>
        )
      })
    }
  }

  renderSuccess () {
    if (this.state.saveSuccess && this.state.successType === 'message') {
      return (
        <h1 className={(this.state.style === 'create' ? 'createHeader' : 'updateHeader')}>{this.state.successMessage}</h1>
      )
    }
    if (this.state.saveSuccess && this.state.successType === 'premium') {
      return (
        <div className='cancelPremium'>
          <h1>Record Saved!</h1>
          <p className=''>The customer's <strong>HME CLOUD Premium Subscription</strong> has now been cancelled.</p>
          <p className=''>However, this account will remain active under the <strong>HME CLOUD Basic Subscription.</strong></p>
          <p className=''>All Premium features will still be available to the customer until the account reaches the account expiration date.</p>
        </div>
      )
    }
  }

  renderModal () {
    let Modal = ReactBootstrap.Modal
    return (
      <Modal show={this.state.show} dialogClassName='adminAccPopUp' onHide={this.handleClose} >
        <Modal.Body className='popUpbody'>
          <h5>Confirmation Required</h5>
          <div className='insideModal'>
            <p className='paraOne'>Are you sure you would like to cancel this subscription?</p>
            <p className='paraTwo'><span className='redText'>*</span>Please Note: Cancelling this subscription will change the account from Premium to Basic.</p>
          </div>
          <div className='buttons-pop-up'>
            <input type='button' onClick={(e) => { this.cancelPremium() }} value='Confirm' />
            <input type='button' onClick={(e) => { this.cancelPremiumPopHide() }} value='Cancel' />
          </div>
        </Modal.Body>
      </Modal>
    )
  }
  validEndDate (current) {
  //  var today = moment()
    var today = moment().subtract(1, 'day')
    return current.isAfter(today)
    // #28587 Phase 3 - Admin - Can't backdate start date of an account
    // return new Date(current).getDate() === 15
  }
  renderForm () {
    const account = this.state
    const regionlist = (datalist, selectedvalue = 0) => {
      if (datalist != null) {
        return datalist.map(item => {
          if (selectedvalue === item.Abbreviation) {
            return <option value={item.Abbreviation} selected={selectedvalue === item.Abbreviation} >{item.Abbreviation + ' - ' + item.Name}</option>
          } else {
            return <option value={item.Abbreviation} >{item.Abbreviation + ' - ' + item.Name}</option>
          }
        })
      }
    }

    const distributorlist = (datalist, selectedvalue = 0) => {
      return datalist.map(item => {
        if (selectedvalue === item.Company_ID) {
          return <option value={item.Company_ID} selected={selectedvalue === item.Company_ID} >{item.Company_Name}</option>
        } else {
          return <option value={item.Company_ID}>{item.Company_Name}</option>
        }
      })
    }

    const brandslist = (datalist, selectedvalue = 0) => {
      return datalist.map(item => {
        if (selectedvalue === item.Uid) {
          return <option value={item.Uid} selected={selectedvalue === item.Uid} >{item.Name}</option>
        } else {
          return <option value={item.Uid}>{item.Name}</option>
        }
      })
    }

    return (
      <div>
        <div className={'' + (this.state.showCommonLoader ? 'fixedIt-add-adm-acc' : '')}>
          <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
        </div>
        <div className={'add-adm-acc clear ' + (account.saveSuccess ? 'hide' : 'show')}>
          <h3 className={(account.update ? 'hide' : '')}>Create an Account</h3>
          <h3 className={(account.update ? '' : 'hide')}>Account Information </h3>
          <h4 className={(account.update ? 'hide' : '')}>Tell us a little about the customer</h4>
          <div className={' error redbox_err_all redbox_marg ' + (account.errors.length ? 'show' : 'hide')} >
            <ul>
              {this.renderErrors()}
            </ul>
          </div>

          <form>
            <div className='row'>
              <div className='col-sm-5 col-md-6'>
                <div className='partial-left'>
                  <table className='admin_acc_form'>
                    <tbody>
                      <tr>
                        <th className='req'><label>First Name:</label></th>
                        <td><input type='text' name='User_FirstName' value={account.User_FirstName} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='req'><label>Last Name:</label></th>
                        <td><input type='text' name='User_LastName' value={account.User_LastName} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='req'><label>Avante Number:</label></th>
                        <td><input type='text' name='Company_AvanteCust_ID' value={account.Company_AvanteCust_ID} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='req'><label>Company Name:</label></th>
                        <td><input type='text' name='Company_Name' value={account.Company_Name} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='req'><label>Company Country:</label></th>
                        <td>
                          <select name='Company_Country_ID' onChange={(e) => { this.handleInputChange(e) }}>
                            <CountryOptions countryList={this.props.countries} selectedCountryId={account.Company_Country_ID} />
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <th className='req'><label>Company {account.Company_Country_ID == 1 ? 'State' : 'Region'}:</label></th>
                        <td className={(account.Company_Country_ID !== 1 ? 'show' : 'hide')} >
                          <input type='text' name='Company_Region' value={account.Company_Region} onChange={(e) => { this.handleInputChange(e) }} />
                        </td>
                        <td className={(account.Company_Country_ID === 1 ? 'show' : 'hide')}>
                          <select name='Company_Region' onChange={(e) => { this.handleInputChange(e) }}>
                            <option value=''>***Select Your State***</option>
                            {regionlist(this.props.regions, account.Company_Region)}
                          </select>
                        </td>
                      </tr>

                      <tr className={'f-12 ' + (account.Company_Type !== 'Distributor' ? '' : 'hide')}>
                        <th><label>Distributor:</label></th>
                        <td>
                          <select name='Distributor_id' onChange={(e) => { this.handleInputChange(e) }}>
                            <option value=''>***Select Distributor***</option>
                            {distributorlist(this.props.distributors, account.Distributor_id)}
                          </select>
                        </td>
                      </tr>

                      <tr className={'f-12 ' + (account.Company_Type !== 'Distributor' ? '' : 'hide')}>
                        <th className='req'><label>Company Type:</label></th>
                        <td><input type='radio' name='Company_Type' className='f-12' value='Franchise'
                          checked={account.Company_Type === 'Franchise'}
                          onChange={(e) => { this.handleInputChange(e) }} />Franchise</td>
                      </tr>

                      <tr className={'f-12 ' + (account.Company_Type !== 'Distributor' ? '' : 'hide')}>
                        <th />
                        <td>
                          <input type='radio' name='Company_Type' className='f-12' value='Corporation'
                            checked={account.Company_Type === 'Corporation'}
                            onChange={(e) => { this.handleInputChange(e) }} />Corporation
                          <select name='Brand_UID' onChange={(e) => { this.handleInputChange(e) }}>
                            <option value='' selected='selected'>***Select Corporate Brand***</option>
                            {brandslist(this.props.brands, account.Brand_UID)}
                          </select>
                        </td>
                      </tr>

                      <tr className={'f-12 ' + (account.Company_Type === 'Distributor' ? '' : 'hide')}>
                        <th className='req'><label>Company Type:</label></th>
                        <td><input type='radio' name='Company_Type' value='Distributor' checked={account.Company_Type === 'Distributor'} />Distributor</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='row hidden-xs'>
                    <div className={'col-sm-12 f-12 ' + (account.update ? 'hide' : '')}>
                      <input type='button' onClick={(e) => { this.handleSubmit() }} value='Create Account' />
                      &nbsp;|&nbsp;<a className='cancel_butt' onClick={(e) => {
                        this.authService.clearUUID()
                        this.navigateToAccounts()
                      }}>Cancel</a>
                    </div>
                    <div className={'col-sm-12 f-12 ' + (account.update ? '' : 'hide')} >
                      <input type='button' onClick={(e) => { this.handleSubmit() }} value='Save' />
                      &nbsp;|&nbsp;<a className='cancel_butt' onClick={(e) => {
                        this.authService.clearUUID()
                        this.navigateToAccounts()
                      }}>Cancel</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-sm-7 col-md-6'>
                <div className='partial-right'>
                  <table className='admin_acc_form'>
                    <tbody>
                      <tr>
                        <th />
                        <td>
                          <a onClick={(e) => { this.handleActivation() }} className={'f-12 pl-40 resend ' + (account.update ? '' : 'hide')}>Resend activation email</a>
                        </td>
                      </tr>
                      <tr>
                        <th><label>Test Account:</label></th>
                        <td>
                          <input type='hidden' name='Account_IsTest' value='0' />
                          <input type='checkbox' name='Account_IsTest'
                            checked={account.Account_IsTest === 1}
                            onChange={(e) => { this.handleCheckboxChange(e, !account.Account_IsTest) }} />
                        </td>
                      </tr>

                      <tr>
                        <th><label>DFA Enabled:</label></th>
                        <td>
                          <input type='checkbox' name='Account_IsDFA'
                            checked={account.Account_IsDFA === 1}
                            onChange={(e) => { this.handleCheckboxChange(e, !account.Account_IsDFA) }} />
                        </td>
                      </tr>
                      <tr>
                        <th className='req'><label>Email address:</label></th>
                        <td><input type='email' name='User_EmailAddress' value={account.User_EmailAddress} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='req'><label>Confirm Email address:</label></th>
                        <td><input type='email' name='User_EmailAddress_confirm' value={account.User_EmailAddress_confirm} onChange={(e) => { this.handleInputChange(e) }} /></td>
                      </tr>
                      <tr>
                        <th className='req'><label>Subscription Start Date:</label></th>
                        <td className='subscription-dates'>
                          <DateTimeField
                            locale={this.state.currentLanguage === 1 ? 'fr-ca' : 'en'}
                            className='date-time'
                            // mode={date}
                            minDate={moment()}
                            maxDate={moment().add(2, 'days')}
                            timeFormat={false}
                            inputProps={{ readOnly: true }}
                            closeOnSelect
                            name='Account_StartDate'
                            ref='Account_StartDate'
                            value={account.Account_StartDate}
                            onChange={e => this.changeDate(e, 'from')}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th className='req'><label>Subscription End Date:</label></th>
                        <td className='subscription-dates'>
                          <DateTimeField
                            locale={this.state.currentLanguage === 1 ? 'fr-ca' : 'en'}
                            className='date-time'
                            minDate={moment().subtract(1, 'days')}
                            maxDate={moment().add(2, 'days')}
                            // mode={date}
                            timeFormat={false}
                            inputProps={{ readOnly: true }}
                            closeOnSelect
                            name='Account_EndDate'
                            ref='Account_EndDate'
                            value={account.Account_EndDate}
                            onChange={e => this.changeDate(e, 'to')}
                            isValidDate={this.validEndDate}
                          />
                        </td>
                      </tr>
                      <tr className={'f-12 ' + (account.updateSubscriptionId === 0 ? '' : 'hide')}>
                        <th className='req'><label>Subscription Type:</label></th>
                        <td>
                          <input type='radio' className='pull-left' value='3'
                            checked={account.Account_Subscription_radio === '3'}
                            onChange={(e) => { this.handleRadioChange(e, 3) }} />
                          <div className='pull-left radio-label'>Basic Store Subscription</div>
                        </td>
                      </tr>
                      <tr className={'f-12 ' + (account.updateSubscriptionId === 0 ? '' : 'hide')} >
                        <th />
                        <td>
                          <input type='radio' className='pull-left' value='8'
                            checked={account.Account_Subscription_radio === '8'}
                            onChange={(e) => { this.handleRadioChange(e, 8) }} />
                          <div className='pull-left radio-label'>Basic Store with Upgrades Subscription</div>
                        </td>
                      </tr>

                      <tr className={'f-12 ' + (account.updateSubscriptionId === 0 ? 'hide' : '')} >
                        <th className='req paddingth' >
                          <label>Subscription Type:</label>
                        </th>
                        <td>
                          <input type='radio' className='pull-left' value='8'
                            checked={account.Account_Subscription_radio === '8'}
                            onChange={(e) => { this.handleRadioChange(e, 8) }} />
                          <div className='pull-left radio-label'>Basic Store with Upgrades Subscription</div>
                        </td>
                      </tr>

                      <tr className='f-12'>
                        <th />
                        <td>
                          <input type='radio' className='pull-left' value='4'
                            checked={account.Account_Subscription_radio === '4'}
                            onChange={(e) => { this.handleRadioChange(e, 4) }} />
                          <div className='pull-left radio-label'>Premium Store Subscription</div>
                        </td>
                      </tr>
                      <tr className='f-12'>
                        <th />
                        <td>
                          <input type='radio' className='pull-left' value='6'
                            checked={account.Account_Subscription_radio === '6'}
                            onChange={(e) => { this.handleRadioChange(e, 6) }} />
                          <div className='pull-left radio-label'>Premium Store with Drive-Thru Leaderboard Subscription</div>
                        </td>
                      </tr>
                      <tr className={'f-12 ' + (account.leaderBoard ? '' : 'hide')}>
                        <th>
                          <label>Leaderboard Version:</label>
                        </th>
                        <td>
                          <div>
                            <input type='radio' name='LBVersion' className='f-12' value='hme'
                              checked={account.LBVersion === 'hme'}
                              onChange={(e) => { this.handleInputChange(e) }} />2.x

                            <input type='radio' name='LBVersion' className='f-12' value='azure'
                              checked={account.LBVersion === 'azure'}
                              onChange={(e) => { this.handleInputChange(e) }} />3.x
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='row hidden-xs'>
                    <div className={'col-sm-12 f-12 text-right ' + ((account.update && account.updateSubscriptionId === 0) || (!account.update) ? 'hide' : '')}>
                      <input type='button' onClick={(e) => { this.cancelPremiumPopShow() }} value='Cancel Premium Subscription' />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row hidden-sm hidden-md hidden-lg hidden-xl'>
              <div className={'col-sm-6 f-12 ' + (account.update ? 'hide' : '')}>
                <input type='button' onClick={(e) => { this.handleSubmit() }} value='Create Account' />
                &nbsp;|&nbsp;<a className='cancel_butt' onClick={(e) => {
                  this.authService.clearUUID()
                  this.navigateToAccounts()
                }}>Cancel</a>
              </div>
              <div className={'col-sm-6 f-12 ' + (account.update ? '' : 'hide')} >
                <input type='button' onClick={(e) => { this.handleSubmit() }} value='Save' />
                &nbsp;|&nbsp;<a className='cancel_butt' onClick={(e) => {
                  this.authService.clearUUID()
                  this.navigateToAccounts()
                }}>Cancel</a>
              </div>
              <div className={'col-sm-6 f-12 text-right ' + ((account.update && account.updateSubscriptionId === 0) || (!account.update) ? 'hide' : '')}>
                <input type='button' onClick={(e) => { this.cancelPremiumPopShow() }} value='Cancel Premium Subscription' />
              </div>
            </div>
          </form>
          {this.renderModal()}
        </div>
        <div className={'add-adm-acc clear ' + (account.saveSuccess ? 'show' : 'hide')}>
          {this.renderSuccess()}
        </div>
      </div>
    )
  }

  render () {
    if (this.authService.isAdmin()) {
      return this.renderForm()
    } else {
      window.location.href = '/myAccount'
      return <div />
    }
  }
  navigateToAccounts () {
    let url = (window.location.pathname.indexOf('/admin') === -1) ? '/myAccount' : '/admin/accounts'
    window.location.href = url
  }
}

function mapStateToProps (state) {
  return {
    countries: state.country.countries,
    brands: state.brands.brands,
    regions: state.region.regions,
    distributors: state.distributor.distributors,
    userAccounts: state.userAccounts.userAccounts
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getCountryList,
      getBrandList,
      getUserAccountDetails,
      getDistributorList,
      getRegionList
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(AdminAccountInfo)



// WEBPACK FOOTER //
// ./src/components/Account/AddAccount.js